import { forwardRef, useImperativeHandle, useCallback } from 'react';
import { Form, Input } from 'antd';
import { useProcContext } from '@/entities/proc';
import { useProcManageActions } from '@/features/proc-management';

type InputEditFormValues = {
  label: string;
  placeholder: string;
};

export const InputEditForm = forwardRef((_, ref) => {
  const [form] = Form.useForm();
  const { selectedComponent, selectedStep, setSelectedComponent } =
    useProcContext();
  const { updateStepComponent, updateComponentLoading } =
    useProcManageActions();

  const onSubmit = useCallback(
    async ({ label, placeholder }: InputEditFormValues) => {
      updateStepComponent({
        stepId: selectedStep?.id || '',
        data: {
          id: selectedComponent?.id,
          label,
          placeholder,
          component: selectedComponent?.component,
          componentName: selectedComponent?.componentName,
        },
        onSuccess: () => setSelectedComponent(undefined),
      });
    },
    [
      selectedStep?.id,
      selectedComponent,
      setSelectedComponent,
      updateStepComponent,
    ],
  );

  useImperativeHandle(
    ref,
    () => ({
      submit: () => onSubmit(form.getFieldsValue()),
      isLoading: updateComponentLoading,
    }),
    [form, onSubmit, updateComponentLoading],
  );

  return (
    <Form
      form={form}
      name="inputEditForm"
      onFinish={onSubmit}
      initialValues={{
        label: selectedComponent?.label,
        placeholder: selectedComponent?.placeholder,
      }}
      autoComplete="off"
      layout="vertical"
      style={{ width: '100%' }}
    >
      <Form.Item label="Label" name="label" style={{ width: '100%' }}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Placeholder text"
        name="placeholder"
        style={{ width: '100%' }}
      >
        <Input />
      </Form.Item>
    </Form>
  );
});

InputEditForm.displayName = 'InputEditForm';
